import { render } from "./FloatButton.vue?vue&type=template&id=2e01d166&scoped=true"
import script from "./FloatButton.vue?vue&type=script&lang=js"
export * from "./FloatButton.vue?vue&type=script&lang=js"

import "./FloatButton.vue?vue&type=style&index=0&id=2e01d166&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e01d166"]])

export default __exports__